import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {


    constructor(private http: HttpClient) { }
  
    public getCurrency(page: any) {
      return this.http.post<any>("/api/v1/amjam/authentication/currency/getcurrencybypagination", page);
    }
  
    public searchKey(page: any) {
      return this.http.post<any>("/api/v1/amjam/authentication/currency/search", page);
    }
  
    public add(data: any) {
      return this.http.post<any>("/api/v1/amjam/authentication/currency/add", data);
    }
  
    public delete(id: any) {
      return this.http.delete<any>("/api/v1/amjam/authentication/currency/delete/" + id);
    }

    public update(data: any) {
      return this.http.put<any>("/api/v1/amjam/authentication/currency/update/",data);
    }

    public get(id: any) {
      return this.http.get<any>("/api/v1/amjam/authentication/currency/get/"+id);
    }
}
